import type { BriefApproval, BriefState } from "../../../shared/types";

/** The brief page for an approved draft (opens on the draft). */
export function approvedBriefPath(brandId: string, campaignId: string, briefId: string): string {
  return `/brand/${encodeURIComponent(brandId)}/campaigns/${encodeURIComponent(campaignId)}/briefs/${encodeURIComponent(briefId)}?document=draft`;
}

export function approverLabel(approvedBy: BriefApproval["approved_by"]): string {
  return approvedBy?.name?.trim() || approvedBy?.email?.trim() || "an operator";
}

export function formatApprovalTime(iso: string | null): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

/** States a brief only reaches through approval. */
export const POST_APPROVAL_STATES: ReadonlySet<BriefState> = new Set(["approved", "scheduled", "published"]);

export function approvedStateLabel(state: BriefState): string {
  return state === "published" ? "Published" : state === "scheduled" ? "Scheduled, not published" : "Approved, not published";
}

/** Approval records a decision. It never posts anything. */
export const APPROVAL_DOES_NOT_PUBLISH = "Approval records your decision; it does not publish. Post it on its surface, then record the published URL in Review.";

/** For blog posts: approval readies the draft for site-agent handoff, not platform posting. */
export const BLOG_APPROVAL_HANDOFF = "Approval records your decision. Mark this post Ready to publish so your site agent can publish it to your site.";

/** Surface-specific publishing instruction. Blog surfaces describe the site-agent handoff; all other surfaces retain the social posting instruction. */
export function approvalPublishNote(surface: string | null | undefined): string {
  const normalized = surface?.trim().toLowerCase();
  if (normalized === "blog" || normalized === "website") return BLOG_APPROVAL_HANDOFF;
  return APPROVAL_DOES_NOT_PUBLISH;
}
